import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import Hero from '../components/Hero.jsx';
import ProductCard from '../components/ProductCard.jsx';
import { useStore } from '../context/StoreContext.jsx';

const newest = (a, b) => String(b.createdAt || '').localeCompare(String(a.createdAt || ''));

function Empty({ text }) {
  return <p className="empty empty--center">{text}</p>;
}

export default function Home() {
  const { settings, products } = useStore();
  const [tab, setTab] = useState('clothing');

  const arrivals = useMemo(() => {
    const inTab = products.filter((p) => p.mainCategory === tab).sort(newest);
    const flagged = inTab.filter((p) => p.newArrival);
    return (flagged.length ? flagged : inTab).slice(0, 8);
  }, [products, tab]);

  const best = useMemo(() => products.filter((p) => p.bestSeller).sort(newest).slice(0, 8), [products]);

  return (
    <>
      <Hero banners={settings.banners} />

      <section className="section section--tight">
        <div className="tiles">
          <Link to="/shop/clothing" className="tile" style={{ backgroundImage: 'url(/banners/tile-clothing.jpg)' }}>
            <span className="tile__label">Clothing</span><span className="tile__btn">Shop now</span>
          </Link>
          <Link to="/shop/handbags" className="tile" style={{ backgroundImage: 'url(/banners/tile-handbags.jpg)' }}>
            <span className="tile__label">Handbags</span><span className="tile__btn">Shop now</span>
          </Link>
          <Link to="/korean-wear" className="tile" style={{ backgroundImage: 'url(/banners/tile-soon.jpg)' }}>
            <span className="tile__label">Korean Wear</span><span className="tile__btn">Coming soon</span>
          </Link>
        </div>
      </section>

      <section className="section">
        <p className="eyebrow">New arrivals</p>
        <div className="tabs">
          <button type="button" className={tab === 'clothing' ? 'is-active' : ''} onClick={() => setTab('clothing')}>Clothing</button>
          <button type="button" className={tab === 'handbags' ? 'is-active' : ''} onClick={() => setTab('handbags')}>Handbags</button>
        </div>
        {arrivals.length ? (
          <div className="grid">{arrivals.map((p) => <ProductCard key={p.id} product={p} />)}</div>
        ) : <Empty text="New pieces are coming soon." />}
        <div className="center"><Link to="/shop/new-arrivals" className="btn">View all</Link></div>
      </section>

      <section className="section section--rule">
        <p className="eyebrow">Customer favourites</p>
        <h2 className="section__title">Best Sellers</h2>
        {best.length ? (
          <div className="grid">{best.map((p) => <ProductCard key={p.id} product={p} />)}</div>
        ) : <Empty text="Our best sellers will appear here soon." />}
        {best.length > 0 && <div className="center"><Link to="/shop/best-sellers" className="btn">View all</Link></div>}
      </section>

      <section className="section section--rule">
        <ul className="perks">
          <li><strong>Cash on delivery</strong><span>Pay when your order arrives</span></li>
          <li><strong>Nationwide shipping</strong><span>{settings.shipping?.freeOver ? `Free over Rs ${Number(settings.shipping.freeOver).toLocaleString('en-PK')}` : 'Delivered to your door'}</span></li>
          <li><strong>Sizes XS to XXL</strong><span>Choose your size on every piece</span></li>
        </ul>
      </section>
    </>
  );
}
